import React, { useState, useContext, useEffect } from 'react';
import {
  checkAllTrue,
  getAndCheck,
  getCurrentLocation,
  getDispositionTypeOnAPIFormat,
  getFullImagePath,
  getPrice,
  getTernaryValue,
  isEmptyEvery,
  isEmptyObject,
  safeUpperCase,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import PRODUCT_CONSTANTS from '../Constants/ProductListingModalOptionsConstants';
import { UpsizeSeelectAnalytics } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getSavedIsDefault,
  getSavedIsEdit,
  getSavedPrice,
  revertCustomizationOnUncheck,
  updateItemPrice,
  updateItemPriceForCheckbox,
  updateModifier,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import PRODUCT_CUSTOM_CONSTANTS from 'organisms/ProductListingCustomizationComponent/Constants/CustomizationConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { priceFixed_value, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';

export const onSaveProductCommon = (
  analyticsObject,
  currLocation,
  analyticspayload,
  min,
  max,
  selectedProduct,
  savedModifierHandler,
  setSelectedProduct,
  cardData,
  savedModifiers,
  userOrderState,
  userOrderStateDispatch,
  modGrpName,
  pdpPayloadData,
  objPath,
  isL3Custom, //to set key to update dynamically for L2, L3
  forModal, //to restrict recommendation item customization,
) => {
  const { HASH_SYMBOL } = MENU_PDP_PAGE_CONSTANTS;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { SINGLE } = PRODUCT_CONSTANTS;
  let getPayloadUpdated, updatedPrice;
  //update payload price for current selection
  let modifierPrice = isEmptyObject(pdpPayloadData) ? getSavedPrice(pdpPayloadData, objPath, 1) : '';
  if (min === 1 || checkAllTrue([!selectedProduct, savedModifiers.length >= min, savedModifiers.length === max])) {
    //if not selected set objpath for already selected item and get price for that, flag to pass will be 'minus'
    upsizeSelectedAnalytics(analyticspayload, selectedProduct);
    if (checkAllTrue([!selectedProduct, isEmptyObject(pdpPayloadData), !forModal])) {
      let idsArr = objPath.split(HASH_SYMBOL);
      idsArr.pop();
      let existingItemId = getTernaryValue(
        savedModifiers.length > 1,
        savedModifiers[1]?.itemId,
        savedModifiers[0]?.itemId,
      );
      idsArr.push(existingItemId);
      let existingItemPath = idsArr.join(HASH_SYMBOL);
      let existingItemPrice = getSavedPrice(pdpPayloadData, existingItemPath, 1);
      getPayloadUpdated = updateItemPrice(
        pdpPayloadData,
        { price: modifierPrice, flag: QUANTITY_ACTION.Increase },
        isL3Custom,
      );
      getPayloadUpdated = updateItemPrice(
        getPayloadUpdated,
        { price: existingItemPrice, flag: QUANTITY_ACTION.Decrease },
        isL3Custom,
      );
      if (getSavedIsEdit(pdpPayloadData, existingItemPath)) {
        //if modifier with edit button is getting unchecked
        //make edit button text to customize and revert all customization for all modgroups for the unchecked item
        //reduce unchecked itemPrice
        getPayloadUpdated = revertCustomizationOnUncheck(getPayloadUpdated, existingItemPath);
      }
      if (isL3Custom) {
        updatedPrice = userOrderState.sopacPDPCustomization.updatedPrice + modifierPrice - existingItemPrice;
      }
    }
    !selectedProduct && setSelectedProduct(true);
    savedModifierHandler(cardData, SINGLE, savedModifiers);
    confirmUpsizeData(updatedPrice, getPayloadUpdated, modGrpName, userOrderStateDispatch);
  } else if (checkAllTrue([selectedProduct, savedModifiers.length > min, savedModifiers.length <= max])) {
    setSelectedProduct(false);
    savedModifierHandler(cardData, false, savedModifiers);
    let unselectedData = updateItemPriceForCheckbox(
      pdpPayloadData,
      forModal,
      cardData.modgrps,
      getPayloadUpdated,
      modifierPrice,
      isL3Custom,
      updatedPrice,
      userOrderState,
      QUANTITY_ACTION.Decrease,
    );
    getPayloadUpdated = unselectedData.getPayloadUpdated;
    updatedPrice = unselectedData.getUpdatedPrice;
    confirmUpsizeData(updatedPrice, getPayloadUpdated, modGrpName, userOrderStateDispatch);
  } else if (checkAllTrue([!selectedProduct, savedModifiers.length >= min, savedModifiers.length < max])) {
    upsizeSelectedAnalytics(analyticspayload, selectedProduct);
    setSelectedProduct(true);
    savedModifierHandler(cardData, true, savedModifiers, true);
    let selectedData = updateItemPriceForCheckbox(
      pdpPayloadData,
      forModal,
      cardData.modgrps,
      getPayloadUpdated,
      modifierPrice,
      isL3Custom,
      updatedPrice,
      userOrderState,
      QUANTITY_ACTION.Increase,
    );
    getPayloadUpdated = selectedData.getPayloadUpdated;
    updatedPrice = selectedData.getUpdatedPrice;
    confirmUpsizeData(updatedPrice, getPayloadUpdated, modGrpName, userOrderStateDispatch);
  }
};

const confirmUpsizeData = (updatedPrice, getPayloadUpdated, modGrpName, userOrderStateDispatch) => {
  const { CONFIRM_UPSIZE_ANALYTICS } = START_ORDER_CONSTANTS;
  const { PDP_PAYLOAD_DATA, UPDATE_SHOW_PDP_CUSTOM_MODAL } = MENU_PDP_PAGE_CONSTANTS;
  userOrderStateDispatch({ type: UPDATE_SHOW_PDP_CUSTOM_MODAL, value: { updatedPrice } });
  isEmptyObject(getPayloadUpdated) && userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: getPayloadUpdated });
  userOrderStateDispatch({
    type: CONFIRM_UPSIZE_ANALYTICS,
    value: { confirmUpsizeName: modGrpName },
  });
};

export const getSelectedFlag = (
  setSelectedFlag,
  setSelectedProduct,
  savedModifierHandler,
  cardData,
  savedModifiers,
) => {
  const { SETFLAGCASE } = PRODUCT_CONSTANTS;
  switch (setSelectedFlag) {
    case SETFLAGCASE.DEFAULT:
    case SETFLAGCASE.FROMEDIT:
      setSelectedProduct(true);
      savedModifierHandler(cardData, true, savedModifiers);
      break;
    case SETFLAGCASE.ITEMINCLUDES:
      setSelectedProduct(true);
      break;
    default:
      setSelectedProduct(false);
      break;
  }
};

const checkIfExistsInCart = (cardId, getCartModifiers) => {
  if (isEmptyObject(getCartModifiers)) {
    let modExists = getCartModifiers.filter(({ id }) => id === cardId);
    return modExists.length > 0 ? true : false;
  } else {
    return false;
  }
};

export const setDefaultFlagCheck = (updatedItems, userOrderState, id, isDefault, getCartModifiers, initialRender) => {
  const { SETFLAGCASE } = PRODUCT_CONSTANTS;
  const { FROMFLAGEDIT } = START_ORDER_CONSTANTS;
  if (updatedItems.length === 0 && initialRender) {
    if (isDefault && userOrderState.minipdpData.fromFlag !== FROMFLAGEDIT) {
      return SETFLAGCASE.DEFAULT;
    } else if (
      userOrderState.minipdpData.fromFlag === FROMFLAGEDIT &&
      getCartModifiers &&
      checkIfExistsInCart(id, getCartModifiers)
    ) {
      return SETFLAGCASE.FROMEDIT;
    }
  } else if (updatedItems?.includes(id)) {
    return SETFLAGCASE.ITEMINCLUDES;
  }
};

const getClassName = (cardType, selectedProduct) => {
  return `${cardType === 'carousal' ? 'carousal-modifier-item-card' : 'modifier-item-card'} ${
    selectedProduct ? 'selected' : ''
  }`;
};
const getSourceClassName = cardType => {
  return cardType === 'carousal' ? 'carousal-modifier-product-save' : 'modifier-product-save';
};
const getImageClassName = cardType => {
  return cardType === 'carousal' ? 'carousal-modifier-card-image' : 'modifier-card-image';
};
//Change
const upsizeSelectedAnalytics = ({ analyticsObjectData, currLocation }, selectedProduct) => {
  if (!selectedProduct) {
    UpsizeSeelectAnalytics(analyticsObjectData, MENU_PDP_PAGE_CONSTANTS.ADDONS);
  }
};

export const getButtonText = (cardData, modgrpId, pdpPayloadData) => {
  const { CUSTOMIZE_BUTTON_TEXT, EDIT_BUTTON_TEXT } = PRODUCT_CUSTOM_CONSTANTS;
  const { id } = cardData;
  let buttonText = '';
  let objpath = `${modgrpId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${id}`;
  let editFlag = getSavedIsEdit(pdpPayloadData, objpath);
  if (editFlag) {
    buttonText = translateWithI18Next(EDIT_BUTTON_TEXT);
  } else {
    buttonText = translateWithI18Next(CUSTOMIZE_BUTTON_TEXT);
  }
  return buttonText;
};

const ModifierCard = props => {
  const {
    cardData,
    savedModifierHandler,
    savedModifiers,
    cardType,
    tenantReducer,
    modgrpData,
    updatedItems,
    getCartModifiers,
    isMobile,
    isModal,
    initialRender,
    setInitialRender,
    isStoreClosed,
    catalog,
    imageContainerSize,
  } = props;

  const { modgrpId, modGrpName, min, max } = modgrpData;
  const { productId, id, name, size, isDefault, isHidden, modgrps, availability } = cardData;
  let price = getPrice(availability[0], tenantReducer?.currencyConversionFactor).toFixed(priceFixed_value);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { modGroupIdsUpdated },
    pdpPayloadData,
    pdpItemUpsizeId,
  } = userOrderState;
  const { MODGROUP_IDS_UPDATE, UPDATE_DEFAULT_MODGROUP, SHOW_PDP_CUSTOM_MODAL, HASH_SYMBOL, PDP_PAYLOAD_DATA } =
    MENU_PDP_PAGE_CONSTANTS;
  const location = useLocation();
  let userParams = useSelector(data => data.appStateReducer?.userStatus);
  const objpath = `${modgrpId}${HASH_SYMBOL}${id}`;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;
  const dispositionType = dispositionNew?.type && safeUpperCase(getDispositionTypeOnAPIFormat(dispositionNew?.type));

  const customizeClickHandler = (e, idVal, modgrp_id) => {
    e.preventDefault();
    e.stopPropagation();
    userOrderStateDispatch({
      type: SHOW_PDP_CUSTOM_MODAL,
      value: {
        showPDPCustomization: true,
        modifierId: idVal,
        modgrpId: modgrp_id,
        modgrpName: modGrpName,
        updatedPrice: 0,
      },
    });
  };

  useEffect(() => {
    if (pdpItemUpsizeId === productId) {
      let setSelectedFlag = setDefaultFlagCheck(
        updatedItems,
        userOrderState,
        id,
        isDefault,
        getCartModifiers,
        initialRender,
      );
      getSelectedFlag(setSelectedFlag, setSelectedProduct, savedModifierHandler, cardData, savedModifiers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, updatedItems, savedModifiers, isDefault, getCartModifiers, pdpItemUpsizeId]);

  useEffect(() => {
    if (getAndCheck(selectedProduct !== undefined, !isModal)) {
      let prevFlag = getSavedIsDefault(pdpPayloadData, objpath);
      if (getAndCheck(prevFlag !== selectedProduct, prevFlag !== null)) {
        let quantity = selectedProduct ? 1 : 0;
        let updatedData = updateModifier(pdpPayloadData, objpath, quantity);
        userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: updatedData });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  const onSaveProduct = () => {
    if (!isDefault && !modGroupIdsUpdated.includes(modgrpId)) {
      userOrderStateDispatch({ type: MODGROUP_IDS_UPDATE, value: modgrpId });
    } else if (isDefault) {
      let filteredArr = modGroupIdsUpdated.filter(item => item !== modgrpId);
      userOrderStateDispatch({ type: UPDATE_DEFAULT_MODGROUP, value: filteredArr });
    }
    setInitialRender(false);
    let analyticsObject = { name, size };
    let currLocation = getCurrentLocation(location.pathname);
    let analyticspayload = { analyticsObject, currLocation };
    onSaveProductCommon(
      analyticsObject,
      currLocation,
      analyticspayload,
      min,
      max,
      selectedProduct,
      savedModifierHandler,
      setSelectedProduct,
      cardData,
      savedModifiers,
      userOrderState,
      userOrderStateDispatch,
      modGrpName,
      pdpPayloadData,
      objpath,
      false,
      isModal,
    );
  };

  return (
    <LazyLoaderWrapper
      importPath='MODIFIER_CARD_TEMPLATE'
      isHidden={isHidden}
      cssClassName={getClassName(cardType, selectedProduct)}
      onSaveProduct={onSaveProduct}
      imageContainerSize={imageContainerSize}
      imageClassName={getImageClassName(cardType)}
      selectedProduct={selectedProduct}
      sourceClassName={getSourceClassName(cardType)}
      modgrpData={{ ...modgrpData, comboL2: true }}
      cardData={cardData}
      isMobile={isMobile}
      customizeClickHandler={customizeClickHandler}
      localized={userParams.localized}
      showButton={checkAllTrue([modgrps?.length > 0, userParams.localized, !isStoreClosed])}
      isStoreClosed={isStoreClosed}
      toRenderCheckBox={true}
      kilojoule={tenantReducer.kilojoule}
      catalog={catalog}
      price={price}
      defaultImagePath={getFullImagePath(null, tenantReducer, true)}
      currencySymbol={tenantReducer?.currencySymbol}
      dispositionType={dispositionType}
    />
  );
};

export default ModifierCard;
